export function fetchGlobalSettings(state, { page, filter }) {
  return {
    ...state,
    globalSettings: {
      ...state.globalSettings,
      currentPage: page,
      filter: filter || state.globalSettings.filter,
      isFetching: true,
      fetchingErrorMessage: '',
    },
  };
}

export function fetchGlobalSettingsSuccess(state, globalSettings) {
  return {
    ...state,
    globalSettings: {
      ...state.globalSettings,
      numberOfPages: globalSettings.numberOfPages,
      count: globalSettings.count,
      items: globalSettings.items,
      isFetching: false,
      fetchingErrorMessage: '',
    },
  };
}

export function fetchGlobalSettingsFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    globalSettings: {
      ...state.globalSettings,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}

export function updateSetting(state) {
  return {
    ...state,
    globalSettings: {
      ...state.globalSettings,
      isFetching: true,
    },
  };
}

export function updateSettingSuccess(state, updatedSetting) {
  let globalSettings = state.globalSettings;
  if (state.globalSettings.items.length > 0) {
    const settingIndex = state.globalSettings.items.findIndex(x => x._id === updatedSetting._id);
    globalSettings = {
      ...state.globalSettings,
      items: [
        ...state.globalSettings.items.slice(0, settingIndex),
        updatedSetting,
        ...state.globalSettings.items.slice(settingIndex + 1),
      ],
    };
  }
  return {
    ...state,
    globalSettings,
  };
}

export function updateSettingFail(state, error) {
  const errorMessage =
    error.message ? error.message : 'Request failed. Open the browser console for details.';
  return {
    ...state,
    globalSettings: {
      ...state.globalSettings,
      isFetching: false,
      fetchingErrorMessage: errorMessage,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/globalSettings.js
 **/